<template>

  <div class="menu" v-show="show" @mouseleave="close">
    <pur-cont-modal ref="pcm"></pur-cont-modal>
    <div class="menu-item" style="color: rgba(44, 177, 129, 1)" v-if="purchaser && item.provider_contract && item.provider_contract.accept == 1" @click="$refs.pcm.open(item.provider_id)" >
      Заключить договор
    </div>
    <div class="menu-item" v-if="purchaser" style="color: rgba(243,146,32,1);" @click="changeStatus(3)">
      Потенциально интересно
    </div>
    <div class="menu-item" v-if="false">
      Написать
    </div>
    <div class="menu-item" v-if="purchaser" style="color: rgba(235, 87, 87, 1)" @click="changeStatus(2)">
      Отклонить
    </div>
    <div class="menu-item" v-if="!purchaser && item.status != 0" style="color: #2CB181" @click="duplicate()">
      Дублировать КП
    </div>
  </div>
</template>

<script>

import PurContModal from "@/components/modals/purchaser-contract-modal";

export default {
  name: "offer-menu",
  components: {
    PurContModal
  },
  props: {
    item: {
      type: [Object,Array],
      default: null
    },
    canChange: {
      type: Boolean,
      default: null
    },
    type:{
      type: Number,
      default: 1
    },
  },
  created () {
    if(this.item == null) console.trace (`%c [order-menu]item is not selected to menu`, 'background: #222; color: #bada55')
  },
  data: () => ({
    show: false,
    purchaser: false
  }),
  mounted() {
    this.purchaser = localStorage.getItem('type') == 1 ? false : true;
  },
  methods: {
    open(){
      if(this.item == null) return 0;
      this.show = true;
    },
    close(){
      this.show = false;
    },
    // contract() {
    //   this.$emit('contract', this.item.provider_id);
    // },
    changeStatus(val) {
      if (localStorage.getItem('token')) {
        this.$http.post('/change-offer-status', {
          token: localStorage.getItem('token'),
          id: this.item.id,
          status: val
        }).then(({data}) => {
          if (data.success) {
            this.$emit('getOffer')
            this.$toast.success('Статус успешно изменен!');
            this.item.status = val;
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    duplicate() {
      if (localStorage.getItem('token')) {
        this.$http.post('/duplicate-offer', {
          token: localStorage.getItem('token'),
          id: this.item.id
        }).then(({data}) => {
          if (data.success) {
          this.$emit('refresh')
          this.$toast.success('КП продублировано успешно!');
        }
      })
      .catch((error) => {
          console.log(error)
      })
      }
    },
  }
}
</script>

<style scoped lang="scss">

.menu{
  right: 65px;
  margin-top: 14px;
  position: absolute;
  width: calc(380% + 20px);
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 0px 30px rgba(129, 129, 129, 0.25);
  padding: 17px 0;
  z-index: 2;
  flex-direction: column;
  align-items: flex-start!important;
  bottom: 0px;

  &-item{
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
    cursor: pointer;
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #7A818F;
    padding: 5px 17px;
    width: 100%;

    &:hover{
      background-color: rgba(0, 0, 0, .05);
    }
    &.disabled,:hover{
      background-color: unset;
      cursor: unset;
      opacity: .3;
    }

    &.orange{
      color: #F39220;
    }

    &.green{
      color: #2CB181;
    }
  }
}
</style>
